import { FC, ReactNode } from "react";
import { useFormikContext } from "formik";
import { Navigate } from "react-router-dom";
import { FormProps } from "@dashboard/modules/products/types/product-form.types";
import { isService } from "@dashboard/modules/products/utils/service-form.utils";

type ProductTypeRouteGuardProps = {
  children: ReactNode;
  allowedForService?: boolean;
  serviceOnly?: boolean;
};

const ProductTypeRouteGuard: FC<ProductTypeRouteGuardProps> = ({
  children,
  allowedForService = false,
  serviceOnly = false,
}) => {
  const { values } = useFormikContext<FormProps>();
  const service = isService(values);

  if (serviceOnly && !service) {
    return <Navigate to=".." replace />;
  }

  if (service && !allowedForService) {
    return <Navigate to=".." replace />;
  }

  return <>{children}</>;
};

export default ProductTypeRouteGuard;
